export default __webpack_public_path__ + "static/media/logo3.bc5b8d3f.svg";